import type { RegisterB2bData } from "@/Modules/Models/Domain/OnBoarding";
import type { RegisterB2bUserApiQuery } from "@/Modules/Models/Api/OnBoarding";
import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";

import { registerB2bUser } from "@/Services/TherapyApi/OnBoardingFunctional";

import useOnboardingStore from "@/Modules/OnBoarding/Store";

import { danger } from "@/Utils/Debug";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

async function registerB2bUserAH(registerB2bData: RegisterB2bData): Promise<void> {
  const onBoardingStore = useOnboardingStore();
  const apiQuery = transformDataToApiQuery(registerB2bData);

  onBoardingStore.hasErrorInProcess = false;
  onBoardingStore.errorCode = null;
  onBoardingStore.isLoading = true;

  try {
    await registerB2bUser(apiQuery);

    onBoardingStore.isUpdateRegister = true;

    onBoardingStore.setNextStep(null);
  } catch (err: unknown) {
    const code = isApiError(err) ? err["error_code"] : null;

    if (code === ApiErrorCodes.NOT_ALLOWED) {
      onBoardingStore.errorCode = ApiErrorCodes.NOT_ALLOWED;
    }

    if (code === ApiErrorCodes.USER_EXISTS) {
      onBoardingStore.errorCode = ApiErrorCodes.USER_EXISTS;
    }

    danger(code);

    onBoardingStore.hasErrorInProcess = true;
  } finally {
    onBoardingStore.isLoading = false;
  }
}

function transformDataToApiQuery(registerB2bData: RegisterB2bData): RegisterB2bUserApiQuery {
  return {
    source: registerB2bData.source,
    b2b_info: {
      document_number: registerB2bData.b2bInfo.documentNumber,
      location: registerB2bData.b2bInfo.location,
      company_section: registerB2bData.b2bInfo.companySection,
    },
  };
}

export default registerB2bUserAH;
